<template>
    <div>
        <b-row v-if="showAlertNoData">
            <b-col class="text-center">
                No es posible clasificar mediante el factor M, ya que no existen datos
            </b-col>
        </b-row>

        <b-row v-else>
            <b-col md="10"
                   offset-md="1"
            >
                <h4>RANGOS</h4>
                <table class="table table-hover">
                    <thead class="bg-soluquim text-white">
                    <tr>
                        <th class="text-center">
                            VALOR
                        </th>
                        <th class="text-center">
                            FACTOR M
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="i in 5"
                        class="text-center"
                    >
                        <td>
                            {{ 0.1 / 10 ** (i - 1) }} < C(E)L50 ≤ {{ 1 / 10 ** (i - 1) }}
                        </td>
                        <td>{{ 10 ** (i - 1) }}</td>
                    </tr>
                    </tbody>
                </table>
            </b-col>
            <hr>
            <b-col md="10"
                   offset-md="1"
            >
                <h4>FACTOR M</h4>
                <table class="table table-hover">
                    <thead class="bg-soluquim text-white">
                    <tr>
                        <th class="text-center">
                            COMPONENTE
                        </th>
                        <th class="text-center">
                            VALOR
                        </th>
                        <th class="text-center">
                            FACTOR M
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="data.component && data.component.factor_m">
                        <td>{{ data.component.name }}</td>
                        <td class="text-center">
                            {{
                                data.component.min
                            }}
                        </td>
                        <td class="text-center">
                            {{ data.component.factor_m }}
                        </td>
                    </tr>
                    <tr v-else>
                        <td colspan="3"
                            class="text-center"
                        >
                            No se encontró ningún componente
                        </td>
                    </tr>
                    </tbody>
                </table>
            </b-col>

            <b-col md="10"
                   offset-md="1"
                   v-if="data.component && data.component.factor_m"
            >
                <h4>PORCENTAJES</h4>
                <table class="table table-hover">
                    <thead class="bg-soluquim text-white">
                    <tr>
                        <th class="text-center">
                            CATEGORÍA
                        </th>
                        <th class="text-center">
                            PORCENTAJES
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            AGUDA
                            CATEGORÍA 1
                        </td>
                        <td class="text-center">
                            {{ data.cat1 }}%
                        </td>
                    </tr>
                    <tr>
                        <td>
                            AGUDA
                            CATEGORÍA 2
                        </td>
                        <td class="text-center">
                            {{ data.cat2 }}%
                        </td>
                    </tr>
                    <tr>
                        <td>
                            AGUDA
                            CATEGORÍA 3
                        </td>
                        <td class="text-center">
                            {{ data.cat3 }}%
                        </td>
                    </tr>
                    </tbody>
                </table>
            </b-col>

            <b-col md="10"
                   offset-md="1"
                   v-if="data.component && data.component.factor_m && data.result"
            >
                <h4>RESULTADO</h4>
                <table class="table table-hover">
                    <thead class="bg-soluquim text-white">
                    <tr>
                        <th class="text-center">
                            TOXICIDAD AGUDA CAT
                        </th>
                        <th class="text-center">
                            PORCENTAJES
                        </th>
                        <th class="text-center">
                            CRITERIO
                        </th>
                        <th class="text-center">
                            CÓDIGO E INDICACIÓN DE PELIGRO
                            (FRASES H)
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            {{ data.result.category }}
                        </td>
                        <td class="text-center">
                            {{ Math.round(data.result.percentage * 10000) / 10000 }}%
                        </td>
                        <td class="text-center">
                            >= 25
                        </td>
                        <td class="text-center">
                            {{ data.result.code }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </b-col>
        </b-row>

        <classification :classification.sync="classification"/>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import Classification from '../../../components/classification.vue';

export default {
    name: 'factor_m',
    components: {Classification},
    data() {
        return {
            data: {
                component: null,
                cat1: 0,
                cat2: 0,
                cat3: 0,
                result: null
            }
        };
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'raw_material',
            'only_view',
            'grouped_components',
            'classification'
        ]),
        showAlertNoData() {
            let sum = 0;

            this.grouped_components.map(c => {
                if (!!c.toxicity) {
                    if (!!c.toxicity.cl_50_fish) {
                        sum += Math.round(((c.final_percentage / c.toxicity.cl_50_fish) + Number.EPSILON) * 10000) / 10000;
                    }

                    if (!!c.toxicity.ce_50_crustaceans) {
                        sum += Math.round(((c.final_percentage / c.toxicity.ce_50_crustaceans) + Number.EPSILON) * 10000) / 10000;
                    }

                    if (!!c.toxicity.cer_50_algae) {
                        sum += Math.round(((c.final_percentage / c.toxicity.cer_50_algae) + Number.EPSILON) * 10000) / 10000;
                    }
                }
            });

            return !sum;
        }
    },
    async mounted() {
        await this.getGroupedComponents();

        await this.getDataByShortTermAquaticEnvironmentByFactorM()
            .then(data => {
                this.data = data.data;
            });

        await this._getClassification();
    },
    methods: {
        ...mapActions('calculator', [
            'deleteRawMaterial',
            'updateComponents',
            'getGroupedComponents',
            'getClassification',
            'getDataByShortTermAquaticEnvironmentByFactorM'
        ]),
        async _getClassification() {
            await this.getClassification({product_id: this.product.id, danger_code: 'MCAL38'});
        }
    }
};
</script>

